import FoundationSignupForm from '@envato/foundation-signup-form'
import * as React from 'react'

import { config } from '../../../../../common/config'
import { createSession } from '../../../../../common/utils/auth'

import * as styles from './signup.module.css'

const SignUpModalContainer = () => {
  const onSubmitSuccess = (response: any) => {
    if (response.token) {
      createSession(response.token)
        .then(res => {
          // redirect user to confirmation page after creating session
          window.location.href = '/user_confirmation'
        })
        .catch(() => {
          window.location.href = '/error?reason=auth_verify'
        })
    }
  }
  const logoAssetsPath = `${config.assets.PUBLIC_PATH}/images/envato_white.svg`
  const recaptchaKey = config.sso.RECAPTCHA_KEY
  if (!recaptchaKey) {
    return null
  }

  return (
    <div className={styles.root} data-test-selector="sign-up-modal">
      <FoundationSignupForm
        logoAssetsPath={logoAssetsPath}
        recaptchaKey={recaptchaKey}
        onSubmitSuccess={onSubmitSuccess}
      />
    </div>
  )
}

export default SignUpModalContainer
